import { render, staticRenderFns } from "./GlobalChatbotContainer.vue?vue&type=template&id=07bc1eba&scoped=true"
import script from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
export * from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatbotContainer.vue?vue&type=style&index=0&id=07bc1eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc1eba",
  null
  
)

export default component.exports